<template>
  <v-col cols="12">
    <v-row key="row-customer-phone">
      <v-col cols="6" class="pa-0 pb-2 pr-1">
        <v-text-field
          v-model="copyOfForm.customer"
          v-validate="required.customer"
          :label="mess['dialog_request_field_customer']"
          :error-messages="errors.collect('customer')"
          outlined
          dense
          data-vv-name="customer"
        />
      </v-col>

      <v-col cols="6" class="pa-0 pb-2 pl-1">
        <v-text-field
          v-model="copyOfForm.phone"
          v-validate="required.phone"
          :label="mess['dialog_request_field_phone']"
          :error-messages="errors.collect('phone')"
          outlined
          dense
          data-vv-name="phone"
        />
      </v-col>
    </v-row>

    <v-row key="row-request_form-product_group">
      <v-col cols="6" class="pa-0 pb-2 pr-1">
        <v-select
          v-validate="required.request_form"
          v-model="copyOfForm.request_form"
          :items="requestFormItems"
          :label="mess['dialog_request_field_request_form']"
          :error-messages="errors.collect('request_form')"
          item-text="title"
          return-object
          outlined
          dense
          data-vv-name="request_form"
        />
      </v-col>

      <v-col
        v-if="isThereProcess"
        key="col-product_group"
        cols="6"
        class="pa-0 pb-2 pl-1"
      >
        <v-select
          v-model="copyOfForm.service_engineer"
          v-validate="required.service_engineer"
          :items="serviceEngineerItems"
          :label="mess['dialog_request_field_service_engineer']"
          :error-messages="errors.collect('service_engineer')"
          item-text="title"
          return-object
          outlined
          dense
          data-vv-name="service_engineer"
        />
      </v-col>
    </v-row>

    <v-row key="row-date">
      <v-col cols="4" class="pa-0 pb-2 pr-3">
        <v-menu
          v-model="dateOfCompletion.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfCompletion.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfCompletion"
              v-on="on"
              :label="mess['dialog_request_field_date_of_completion']"
              class="request-datepicker-text-field"
              prepend-icon="event"
              readonly
              outlined
              dense
            />
          </template>

          <v-date-picker v-model="dateOfCompletion.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfCompletion.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfCompletion.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-3">
        <v-menu
          v-model="dateOfSale.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfSale.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfSale"
              v-on="on"
              :label="mess['dialog_request_field_date_of_sale']"
              class="request-datepicker-text-field"
              prepend-icon="event"
              readonly
              outlined
              dense
            />
          </template>

          <v-date-picker v-model="dateOfSale.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfSale.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfSale.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-menu
          v-model="dateOfIncident.isOpen"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          @input="dateOfIncident.close($event)"
        >
          <template #activator="{ on }">
            <v-text-field
              v-model="copyOfForm.dateOfIncident"
              v-on="on"
              :label="mess['dialog_request_field_date_of_incident']"
              class="request-datepicker-text-field"
              prepend-icon="event"
              readonly
              outlined
              dense
            />
          </template>

          <v-date-picker v-model="dateOfIncident.date" no-title scrollable>
            <v-spacer />

            <v-btn text color="primary" @click="dateOfIncident.close(false)">
              {{ mess["dialog_base_button_close"] }}
            </v-btn>

            <v-btn text color="primary" @click="dateOfIncident.save">
              {{ mess["dialog_base_button_save"] }}
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>

    <v-row key="row-request_reason">
      <v-col cols="12" class="pa-0 pb-2 d-flex flex-wrap align-start">
        <v-select
          v-model="copyOfForm.request_reason"
          v-validate="required.request_reason"
          :items="requestReasonItems"
          :label="mess['dialog_request_field_request_reason']"
          :error-messages="errors.collect('request_reason')"
          item-text="title"
          return-object
          outlined
          dense
          data-vv-name="request_reason"
        >
          <template #append>
            <v-tooltip top content-class="request-form-tooltip">
              <template #activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="primary" dark>
                  mdi-information-outline
                </v-icon>
              </template>

              <span v-html="tooltips.incident"></span>
            </v-tooltip>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <v-row key="row-incident_description">
      <v-col cols="12" class="pa-0 pb-2">
        <v-textarea
          v-model="copyOfForm.incident_description"
          v-validate="required.incident_description"
          :label="mess['dialog_request_field_incident_description']"
          :error-messages="errors.collect('incident_description')"
          outlined
          dense
          data-vv-name="incident_description"
        >
          <template v-if="tooltips.requestReason" #append>
            <v-tooltip top content-class="request-form-tooltip">
              <template #activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="primary" dark>
                  mdi-information-outline
                </v-icon>
              </template>

              <span v-html="tooltips.requestReason"></span>
            </v-tooltip>
          </template>
        </v-textarea>
      </v-col>
    </v-row>

    <v-row key="row-articles">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.article_element"
          v-validate="required.article_element"
          :items="searchedArticles"
          :search-input.sync="searchElementArticle"
          :label="mess['dialog_request_field_article_element']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('article_element')"
          color="primary"
          outlined
          dense
          item-text="pdm_elementid"
          data-vv-name="article_element"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedArticles',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchElementArticle', 'article_element', $event)
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              <b>{{ item.pdm_elementid }}</b>
              {{ item.pdm_oemarticle }}
            </span>
          </template>

          <template #append>
            <v-tooltip top content-class="request-form-tooltip">
              <template #activator="{ on, attrs }">
                <v-icon v-on="on" v-bind="attrs" color="primary" dark>
                  mdi-information-outline
                </v-icon>
              </template>

              <span v-html="tooltips.articleElement"></span>
            </v-tooltip>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.article_original"
          :items="searchedOriginalArticles"
          :search-input.sync="searchOriginalArticle"
          :label="mess['dialog_request_field_article_original']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('article_original')"
          color="primary"
          outlined
          dense
          item-text="pdm_oemarticle"
          data-vv-name="article_original"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedOriginalArticles',
              'by_oem_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchOriginalArticle', 'article_original', $event)
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              {{ item.pdm_elementid }}
              <b>{{ item.pdm_oemarticle }}</b>
            </span>
          </template>

          <template #append>
            <v-tooltip top content-class="request-form-tooltip">
              <template #activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="primary" dark>
                  mdi-information-outline
                </v-icon>
              </template>

              <span v-html="tooltips.articleOriginal"></span>
            </v-tooltip>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model="copyOfForm.po_n"
          v-validate="required.po_n"
          :label="mess['dialog_request_field_po_n']"
          :error-messages="errors.collect('po_n')"
          outlined
          dense
          data-vv-name="po_n"
        >
          <template #append>
            <v-tooltip
              top
              content-class="request-form-tooltip request-form-tooltip--img"
            >
              <template #activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="primary" dark>
                  mdi-information-outline
                </v-icon>
              </template>

              <div class="request-form-tooltip__img">
                <img
                  style="max-width: 100%; height: auto"
                  src="/assets/img/po_n.png"
                />
              </div>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row
      v-if="isArmorsAndComponentsGroup"
      key="row-disassembling_select"
      :class="[
        'fields-group',
        { 'fields-group--active': isThereAnalog }
      ]"
    >
      <v-col cols="12" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.disassembling"
          v-validate="required.disassembling"
          :items="damages"
          :label="mess['dialog_request_field_disassembling']"
          :error-messages="errors.collect('disassembling')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="disassembling"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isThereAnalog"
      key="row-disassembling_articles"
      class="fields-group fields-group--active"
    >
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.disassembling_article_element"
          v-validate="required.disassembling_article_element"
          :items="searchedArticles"
          :search-input.sync="searchDisassemblingElementArticle"
          :label="mess['dialog_request_field_article_element']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('disassembling_article_element')"
          color="primary"
          outlined
          dense
          item-text="pdm_elementid"
          data-vv-name="disassembling_article_element"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedArticles',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle(
              'searchDisassemblingElementArticle',
              'disassembling_article_element',
              $event
            )
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              <b>{{ item.pdm_elementid }}</b>
              {{ item.pdm_oemarticle }}
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.disassembling_article_original"
          v-validate="required.disassembling_article_original"
          :items="searchedArticles"
          :search-input.sync="searchDisassemblingOriginalArticle"
          :label="mess['dialog_request_field_article_original']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('disassembling_article_original')"
          color="primary"
          outlined
          dense
          item-text="pdm_oemarticle"
          data-vv-name="disassembling_article_original"
          @update:search-input="
            onUpdateArticleSearchInput('searchedArticles', 'by_oem_id', $event)
          "
          @change="
            onChangeArticle(
              'searchDisassemblingOriginalArticle',
              'disassembling_article_original',
              $event
            )
          "
        >
          <template #item="{ item }">
            <span style="font-size: 12px">
              {{ item.pdm_elementid }}
              <b>{{ item.pdm_oemarticle }}</b>
            </span>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-text-field
          v-model="copyOfForm.disassembling_po_n"
          v-validate="required.disassembling_po_n"
          :label="mess['dialog_request_field_po_n']"
          :error-messages="errors.collect('disassembling_po_n')"
          outlined
          dense
          data-vv-name="disassembling_po_n"
        />
      </v-col>
    </v-row>

    <v-row key="row-equipment">
      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-combobox
          v-model="copyOfForm.equipment"
          v-validate="required.equipment"
          :items="equipments"
          :search-input="searchEquipment"
          :label="mess['dialog_request_field_equipment']"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :error-messages="errors.collect('equipment')"
          color="primary"
          outlined
          dense
          hide-no-data
          data-vv-name="equipment"
          @update:search-input="onUpdateEquipmentSearchInput($event)"
          @change="
            onChangeArticle('searchEquipment', 'equipment', $event)
          "
        >
          <template #append>
            <v-tooltip
              top
              content-class="request-form-tooltip"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                >
                  mdi-information-outline
                </v-icon>
              </template>

              <span v-html="tooltips.equipment"></span>
            </v-tooltip>
          </template>
        </v-combobox>
      </v-col>

      <v-col cols="4" class="pa-0 pb-2 pr-2">
        <v-text-field
          v-model="copyOfForm.serial_number"
          :label="mess['dialog_request_field_serial_number']"
          :error-messages="errors.collect('serial_number')"
          outlined
          dense
          data-vv-name="serial_number"
        />
      </v-col>

      <v-col cols="4" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.year"
          :items="years"
          :label="mess['dialog_request_field_year']"
          :error-messages="errors.collect('year')"
          type="number"
          outlined
          dense
          data-vv-name="year"
        />
      </v-col>
    </v-row>

    <v-row
      key="row-damage_1"
      :class="[
        'fields-group',
        { 'fields-group--active': isThereDamage }
      ]"
    >
      <v-col cols="12" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.damage_1"
          v-validate="required.damage_1"
          :items="damages"
          :label="mess['dialog_request_field_damage_1_']"
          :error-messages="errors.collect('damage_1')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="damage_1"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isThereDamage"
      key="row-articles_additional"
      class="fields-group fields-group--active"
    >
      <v-col cols="12" class="pa-0 pb-2">
        <v-combobox
          v-model="copyOfForm.articles"
          :items="searchedArticlesAdditional"
          :search-input.sync="searchArticleAdditional"
          :placeholder="mess['dialog_request_field_articles_start_print']"
          :label="mess['dialog_request_field_articles']"
          multiple
          color="primary"
          outlined
          dense
          chips
          deletable-chips
          item-text="pdm_elementid"
          item-value="id"
          @update:search-input="
            onUpdateArticleSearchInput(
              'searchedArticlesAdditional',
              'by_element_id',
              $event
            )
          "
          @change="
            onChangeArticle('searchArticleAdditional', 'articles', $event)
          "
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isThereDamage"
      key="row-damage_description"
      class="fields-group fields-group--active mb-2"
    >
      <v-col cols="12" class="pa-0">
        <v-textarea
          v-model="copyOfForm.damage_description"
          v-validate="required.damage_description"
          :label="mess['dialog_request_field_damage_description']"
          :error-messages="errors.collect('damage_description')"
          outlined
          dense
          data-vv-name="damage_description"
        />
      </v-col>
    </v-row>

    <v-row
      v-if="isArmorsAndComponentsGroup"
      key="row-damage_2"
    >
      <v-col cols="12" class="pa-0 pb-2">
        <v-select
          v-model="copyOfForm.damage_2"
          v-validate="required.damage_2"
          :items="damages"
          :label="mess['dialog_request_field_damage_2']"
          :error-messages="errors.collect('damage_2')"
          return-object
          item-text="title"
          outlined
          dense
          data-vv-name="damage_2"
        />
      </v-col>
    </v-row>

    <v-row key="row-customer_requirements">
      <v-col cols="12" class="pa-0 pb-2">
        <v-textarea
          v-model="copyOfForm.customer_requirements"
          v-validate="required.customer_requirements"
          :label="mess['dialog_request_field_customer_requirements']"
          :error-messages="errors.collect('customer_requirements')"
          outlined
          dense
          data-vv-name="customer_requirements"
        />
      </v-col>
    </v-row>

    <v-row key="row-units" class="align-center pb-4">
      <v-col cols="auto" class="pa-0">
        <p class="ma-0">
          {{ mess["dialog_request_label_units_of_measurement"] }}
        </p>
      </v-col>

      <v-col cols="auto" class="pa-0">
        <v-radio-group
          v-model="copyOfForm.optime_unit"
          class="ma-0"
        >
          <template #append>
            <v-row class="flex-nowrap">
              <v-col>
                <v-radio
                  value="ton"
                  color="primary"
                  :label="mess['dialog_request_button_units_ton']"
                />
              </v-col>

              <v-col class="pl-0">
                <v-radio
                  value="hours"
                  color="primary"
                  :label="mess['dialog_request_button_units_hours']"
                />
              </v-col>

              <v-col class="pl-0">
                <v-radio
                  value="custom"
                  color="primary"
                  :label="mess['dialog_request_button_units_customs']"
                />
              </v-col>
            </v-row>
          </template>
        </v-radio-group>
      </v-col>

      <v-col
        v-if="isCustomUnit"
        class="pa-0"
      >
        <v-text-field
          v-model="copyOfForm.custom_unit"
          v-validate="required.custom_unit"
          :label="mess['dialog_request_field_custom_unit']"
          :error-messages="errors.collect('custom_unit')"
          outlined
          dense
          hide-details
          data-vv-name="custom_unit"
        >
          <template #append>
            <v-tooltip
              top
              content-class="request-form-tooltip"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  dark
                >
                  mdi-information-outline
                </v-icon>
              </template>

              <span v-html="tooltips.unitCustom"></span>
            </v-tooltip>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row key="row-optime" class="align-center">
      <v-col
        v-if="isArmorsAndComponentsGroup"
        cols="3"
        class="pa-0 pb-2 pr-3"
      >
        <v-text-field
          v-model.number="copyOfForm.optime_plan"
          v-validate="required.optime_plan"
          :label="`${mess['dialog_request_field_optime_plan']}, ${optimeUnit}`"
          :error-messages="errors.collect('optime_plan')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_plan"
        />
      </v-col>

      <v-col cols="3" class="pa-0 pb-2 pr-3">
        <v-text-field
          v-model.number="copyOfForm.optime_actual"
          :label="
            `${mess['dialog_request_field_optime_actual']}, ${optimeUnit}`
          "
          :error-messages="errors.collect('optime_actual')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_actual"
        />
      </v-col>

      <v-col
        v-if="isArmorsAndComponentsGroup"
        cols="3"
        class="pa-0 pb-2 pr-3"
      >
        <v-text-field
          v-model="optimePercent"
          disabled
          filled
          outlined
          dense
        />
      </v-col>

      <v-col
        v-if="isArmorsAndComponentsGroup"
        cols="3"
        class="pa-0 pb-2"
      >
        <v-text-field
          v-model="copyOfForm.optime_average"
          v-validate="required.optime_average"
          :label="
            `${mess['dialog_request_field_optime_average']}, ${optimeUnit}`
          "
          :error-messages="errors.collect('optime_average')"
          type="number"
          min="0"
          outlined
          dense
          data-vv-name="optime_average"
        />
      </v-col>
    </v-row>

    <v-col
      v-if="isArmorsAndComponentsGroup"
      cols="12"
      class="pa-0"
    >
      <v-row key="row-weight">
        <v-col cols="6" class="pa-0 pb-2 pr-2">
          <v-text-field
            v-model="copyOfForm.weight"
            v-validate="required.weight"
            :label="mess['dialog_request_field_weight']"
            :error-messages="errors.collect('weight')"
            type="number"
            min="0"
            outlined
            dense
            data-vv-name="weight"
          />
        </v-col>
      </v-row>

      <v-row key="row-material-size_1">
        <v-col cols="6" class="pa-0 pb-2 pr-2">
          <v-text-field
            v-model="copyOfForm.material"
            v-validate="required.material"
            :label="mess['dialog_request_field_material']"
            :error-messages="errors.collect('material')"
            outlined
            dense
            data-vv-name="material"
          />
        </v-col>

        <v-col cols="6" class="pa-0 pb-2">
          <v-text-field
            v-model="copyOfForm.size_1"
            v-validate="required.size_1"
            :label="mess['dialog_request_field_size_1']"
            :error-messages="errors.collect('size_1')"
            outlined
            dense
            data-vv-name="size_1"
          />
        </v-col>
      </v-row>

      <v-row key="row-size_2-gap">
        <v-col cols="6" class="pa-0 pb-2 pr-2">
          <v-text-field
            v-model="copyOfForm.size_2"
            v-validate="required.size_2"
            :label="mess['dialog_request_field_size_2']"
            :error-messages="errors.collect('size_2')"
            outlined
            dense
            data-vv-name="size_2"
          />
        </v-col>

        <v-col cols="6" class="pa-0 pb-2">
          <v-text-field
            v-model="copyOfForm.gap"
            :label="mess['dialog_request_field_gap']"
            outlined
            dense
          />
        </v-col>
      </v-row>

      <v-row key="row-stroke-a_size">
        <v-col cols="6" class="pa-0 pb-2 pr-2">
          <v-text-field
            v-model="copyOfForm.stroke"
            :label="mess['dialog_request_field_stroke']"
            outlined
            dense
          >
            <template #append>
              <v-tooltip
                top
                content-class="request-form-tooltip"
              >
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    dark
                  >
                    mdi-information-outline
                  </v-icon>
                </template>

                <span v-html="tooltips.stroke"></span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="6" class="pa-0 pb-2">
          <v-text-field
            v-model="copyOfForm.a_size"
            :label="mess['dialog_request_field_a_size']"
            outlined
            dense
          >
            <template #append>
              <v-tooltip
                top
                content-class="request-form-tooltip"
              >
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    color="primary"
                    dark
                  >
                    mdi-information-outline
                  </v-icon>
                </template>

                <span v-html="tooltips.aSize"></span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-col>
  </v-col>
</template>

<script>
import getArticles from "@/mixins/GetArticles";
import getEquipments from "@/mixins/GetEquipments";
import isNumber from "lodash/isNumber";
import RequestForm from "@/mixins/RequestForm";

/**
 * @memberOf RequestDialog
 * @name CrushingSparesForm
 * @desc Компонент для отрисовки формы "Дробление"
 *
 * @vue-prop { Object } process - Текущий выбранный процесс
 * @vue-prop { Object } group - Текущая выбранная группа
 *
 * @vue-data { Object } copyOfForm - Сюда записываем данные из полей
 * @vue-data { requestDialogDatePicker } dateOfCompletion - Объект для отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfIncident - Объект для отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { requestDialogDatePicker } dateOfSale - Объект для отрисовки datePicker. Детальнее о типе datePickerObject смотри в разделе
 * Globals/Type Definitions
 * @vue-data { String | null } [searchArticleAdditional=null] - Тут хранится введенный в строку поиска element-артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { String | null } [searchDisassemblingElementArticle=null] - Тут хранится введенный в строку поиска original-артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { String | null } [searchDisassemblingOriginalArticle=null] - Тут хранится введенный в строку поиска артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { String | null } [searchEquipment=null] - Тут хранится введенный в строку поиска оборудования текст.
 * @vue-data { String | null } [searchElementArticle=null] - Тут хранится введенный в строку поиска element-артикула текст.
 * @vue-data { String | null } [searchOriginalArticle=null] - Тут хранится введенный в строку поиска артикула текст (для полей поиска артикула которые показываются при разборка аналога = да).
 * @vue-data { Array } [searchedArticles=[]] - Тут хранится результат поиска по артикулам.
 * @vue-data { Array } [searchedArticlesAdditional=[]] - Тут хранится результат поиска по артикулам на основе текста из searchArticleAdditional.
 * @vue-data { Array } [searchedOriginalArticles=[]] - Тут хранится результат поиска по original-артикулам.
 *
 * @vue-computed { Object } damages - Возвращает варианты для select-а "Повреждение сопряженных деталей".
 * @vue-computed { String } currentDate - Текущая дата.
 * @vue-computed { Boolean } isCustomUnit - Проверяет выбрана ли ед измерения custom.
 * @vue-computed { Boolean } isArmorAndComponentsGroup - Проверяет текущую выбранную группу. Если она равна id группы "Брони дробилок и компоненты",
 * то возвращает true. Это нужно для отрисовки доп полей, которых нету в группе "Запчасти дробилок".
 * @vue-computed { Boolean } isThereAnalog - Проверяет значение в поле "Разборка аналога" для отрисовки доп полей,
 * если вернет true.
 * @vue-computed { Boolean } isThereDamage - Проверят значение в поле "Повреждение сопряженных деталей" для отрисовки доп полей,
 * если вернет true.
 * @vue-computed { String } optimePercent - Возвращает процент рассчитанный на основе optime_actual и optime_plan
 * @vue-computed { String } optimeUnit - Возвращает текст в зависимости от выбранной ед измерения
 * @vue-computed { Array } requestFormItems - Возвращает массив элементов для select-a "Форма запроса".
 * @vue-computed { Array } requestReasonItems - Возвращает массив элементов для select-a "Причина обращения".
 * @vue-computed { Array } serviceEngineerItems - Возвращает массив элементов для select-a "Выезд сервисного инжеренра".
 * @vue-computed { Object } tooltips - Возвращает объект объектов, где каждый объект хранит в себе текст для tooltip.
 * @vue-computed { Array } years - Возвращает массив дат.
 *
 * @vue-event initDefaultDates - Метод для проставления текущей даты всем объектам используемым для отрисовки datePicker.
 * Это нужно для того чтобы datePicker не был пустым при открытии поп-апа.
 */
export default {
  name: "CrushingSparesForm",
  inject: ["$validator"],
  mixins: [getArticles, getEquipments, RequestForm],
  props: {
    process: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      copyOfForm: {},
      dateOfCompletion: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfCompletion.isOpen = false;
            this.dateOfCompletion.date = this.copyOfForm.dateOfCompletion;
          }
        },
        save: () => {
          this.copyOfForm.dateOfCompletion = this.dateOfCompletion.date;
          this.dateOfCompletion.close();
        }
      },
      dateOfIncident: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfIncident.isOpen = false;
            this.dateOfIncident.date = this.copyOfForm.dateOfIncident;
          }
        },
        save: () => {
          this.copyOfForm.dateOfIncident = this.dateOfIncident.date;
          this.dateOfIncident.close();
        }
      },
      dateOfSale: {
        date: this.currentDate,
        isOpen: false,
        close: value => {
          if (!value) {
            this.dateOfSale.isOpen = false;
            this.dateOfSale.date = this.copyOfForm.dateOfSale;
          }
        },
        save: () => {
          this.copyOfForm.dateOfSale = this.dateOfSale.date;
          this.dateOfSale.close();
        }
      },
      searchArticleAdditional: null,
      searchDisassemblingElementArticle: null,
      searchDisassemblingOriginalArticle: null,
      searchEquipment: null,
      searchElementArticle: null,
      searchOriginalArticle: null,
      searchedArticles: [],
      searchedArticlesAdditional: [],
      searchedOriginalArticles: []
    };
  },
  computed: {
    damages() {
      return this.process?.params?.damage || [];
    },
    currentDate() {
      return new Date().toISOString().substr(0, 10);
    },
    errors() {
      return {};
    },
    isCustomUnit() {
      return this.copyOfForm.optime_unit === "custom";
    },
    isArmorsAndComponentsGroup() {
      return this.group && parseInt(this.group?.id) === 113450;
    },
    isThereAnalog() {
      return this.group && parseInt(this.copyOfForm.disassembling?.id) === 1;
    },
    isThereDamage() {
      return parseInt(this.copyOfForm.damage_1?.id) === 1;
    },
    isThereProcess() {
      return this.process?.product_group;
    },
    optimePercent() {
      const {
        optime_actual: actual = null,
        optime_plan: plan = null
      } = this.copyOfForm;

      if (!isNumber(actual) || !isNumber(plan)) {
        return (0).toFixed(2) + "%";
      }

      if (actual < 0 || plan <= 0) {
        return (0).toFixed(2) + "%";
      }

      return ((actual / plan) * 100).toFixed(2) + "%";
    },
    optimeUnit() {
      if (!this.copyOfForm.optime_unit) return;

      switch (this.copyOfForm.optime_unit.toString()) {
        case "ton":
          return this.mess["dialog_request_button_units_ton"];
        case "hours":
          return this.mess["dialog_request_button_units_hours"];
        case "custom":
          return this.copyOfForm.custom_unit;
        default:
          return "";
      }
    },
    requestFormItems() {
      return this.process?.params?.request_form || [];
    },
    requestReasonItems() {
      return this.process?.params?.request_reason || [];
    },
    serviceEngineerItems() {
      return this.process?.params?.service_engineer || [];
    },
    tooltips() {
      return {
        requestReason:
          this.process?.params?.request_reason.find(
            reason => reason.id === this.copyOfForm?.request_reason
          )?.description || null,
        articleElement: this.process?.params?.article_element_description,
        articleOriginal: this.process?.params?.article_original_description,
        incident: this.process?.params?.incident_description,
        equipment: this.process?.params?.equipment_description,
        poN: this.process?.params?.po_n_description,
        stroke: this.process?.params?.stroke_description,
        aSize: this.process?.params?.a_size_description,
        unitCustom: this.process?.params?.unit_custom_description
      };
    },
    years() {
      return [...Array(100).keys()].map(
        elem => new Date().getFullYear() - elem
      );
    }
  },
  mounted() {
    this.initDefaultDates();
  },
  methods: {
    initDefaultDates() {
      this.copyOfForm.dateOfCompletion = this.currentDate;
      this.copyOfForm.dateOfIncident = this.currentDate;
      this.copyOfForm.dateOfSale = this.currentDate;
    }
  }
};
</script>
